import { NgModule } from '@angular/core';
import { VTooltipContainerComponent, VTooltipComponent, VTooltipDirective } from './v-tooltip.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports:      [CommonModule, TranslateModule.forChild()],
    declarations: [VTooltipDirective, VTooltipComponent, VTooltipContainerComponent],
    exports:      [VTooltipDirective, VTooltipContainerComponent]

})
export class VTooltipModule { }
